// Collapse a list of crew locations to one row per user — the most
// recent fix per user_id.
//
// The crew_locations_display view is contracted to return one row per
// user per briefing (migration 20260615120000 removed a crew_members
// fan-out that broke this for multi-day festivals). This helper is the
// defensive counterpart on the client: it keeps the marker layer
// idempotent even if a future view change or a raw crew_locations read
// (e.g. LiveTrackingPreviewCard) yields multiple rows per user. Markers
// are keyed by user_id, so any duplicate row leaves an orphan marker
// stranded on the map.
//
// Pure + input-order independent: picks the max-timestamp row per user.
export function dedupeLatestLocationByUser<T extends { user_id: string; timestamp: string }>(
  locations: T[],
): T[] {
  const latestByUser = new Map<string, T>();
  for (const loc of locations) {
    const existing = latestByUser.get(loc.user_id);
    if (!existing || new Date(loc.timestamp).getTime() > new Date(existing.timestamp).getTime()) {
      latestByUser.set(loc.user_id, loc);
    }
  }
  return Array.from(latestByUser.values());
}
